import TitleListState from "@/modules/title-list";
import { NavigationGuardNext, Route } from "vue-router";
import { getModule } from "vuex-module-decorators";

export const RevisionManagerRouteResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const titleListModule = getModule(TitleListState);

	if (!titleListModule.levels.length) {
		await titleListModule.fetchVcsLevels();
	}

	next();
};
